import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setProgressBarStages } from '../../Lib/redux/slices/navigation';
import { buildStages } from '../../Components/StagedProgressBar/StagedProgressBar.helpers';
import { findPostcodePageNumbers } from '../../Components/__helpers__/component.helpers';

/**
 * Custom hook to manage the state of the staged progress bar
 * @param {Object} options - Options for the hook
 * @param {boolean} options.enableStagedProgressBar - Whether the staged progress bar is enabled
 * @param {number} options.currentPage - The current page number
 * @param {number} options.submissionPageNumber - The submission page number
 * @param {Array} options.components - The components array
 * @returns {void}
 */
const useStagedProgressBar = ({
  enableStagedProgressBar,
  submissionPageNumber,
  components,
}) => {
  const dispatch = useDispatch();
  const { pageNumbers } = useSelector((store) => store.paging);
  const { progressBarStages } = useSelector((store) => store.navigation);

  // Effect to setup progress bar stages
  useEffect(() => {
    if (enableStagedProgressBar && progressBarStages?.length === 0) {
      const firstPostcodePageNumber = findPostcodePageNumbers(components)[0];
      const totalPages = pageNumbers.length;
      const lastPageNumber =
        typeof submissionPageNumber === 'number'
          ? submissionPageNumber
          : totalPages - 1;

      const updatedStages = buildStages(
        firstPostcodePageNumber,
        lastPageNumber,
        pageNumbers
      );

      dispatch(setProgressBarStages({ progressBarStages: updatedStages }));
    }
  }, [
    enableStagedProgressBar,
    progressBarStages?.length,
    components,
    pageNumbers,
    submissionPageNumber,
    dispatch,
  ]);

  return { stages: progressBarStages };
};

export default useStagedProgressBar;
